/**
 * *This static class helps in Capitalizing a string
 *Eg:   import { Capitalize } from from '../../helpers';
 *      let str = "2900 PARKWY DALLAS"
 *      Capitalize.toCapitalize(str)   => returns "2900 Parkwy Dallas"
 *
 * */

export default class Capitalize {
    static toCapitalize(s) {
        if (!s) {
            return '';
        }
        const oldStr = s.split(' ');
        const newStr = oldStr.map((i) => {
            if (isNaN(i)) {
                const str =
                    i.substring(1, 0).toUpperCase() + i.substring(1, i.length).toLowerCase();
                return str;
            }
            return i;
        });
        return newStr.join(' ');
    }
}
